export default {
  imgCheckAlt: {
    value: 'img_check_alt',
    defaultMessage: 'Symbole de séléction',
  },
  altImgIconSuccess: {
    value: 'alt_icon_alert_component_success',
    defaultMessage: "C'est validé",
  },
  altImgIconFailure: {
    value: 'alt_icon_alert_component_failure',
    defaultMessage: "Ce n'est pas validé",
  },
  messageErrorMinQuantity: {
    value: 'message_error_min_quantity',
    defaultMessage: 'vouz avez atteint la quantité minimum',
  },
  messageErrorMaxQuantity: {
    value: 'message_error_max_quantity',
    defaultMessage: 'vouz avez atteint la quantité maximum',
  },
  send: {
    value: 'send',
    defaultMessage: 'Envoyer',
  },
  validate: {
    value: 'validate',
    defaultMessage: 'Valider',
  },
  close: {
    value: 'close',
    defaultMessage: 'Fermer',
  },
  back: {
    value: 'back',
    defaultMessage: 'Retour',
  },
  species: {
    value: 'species',
    defaultMessage: `{species, select,
      dog {Chien}
      cat {Chat}
      other {}
    }`,
  },
  kilogramQuantity: {
    value: 'kilogram_quantity',
    defaultMessage:
      '{quantity, number, ::scale/0.001 .0/w measure-unit/kilogram}',
  },
  price: {
    value: 'price',
    defaultMessage: '{price, number, ::currency/EUR}',
  },
  successMessage: {
    value: 'success_update_next_delivery',
    defaultMessage:
      'Vos changements seront pris en compte dans votre prochaine livraison.',
  },
  failureMessage: {
    value: 'failure_update',
    defaultMessage:
      "Vos changements n'ont malheureusement pas été pris en compte.",
  },
  modify: {
    value: 'modify',
    defaultMessage: 'Modifier',
  },
  frequency: `{frequency, select,
    1 {Tous les mois}
    other {Tous les {frequency} mois}
  }`,
  pathologies: {
    value: 'pathologies',
    defaultMessage: `{pathology, select,
      cereal {Maïs / Blé / Orge}
      gluten {Gluten}
      pork {Porc}
      beef {Boeuf}
      chicken {Poulet}
      fish {Poisson}
      other {}
    }`,
  },
}
